import { CopyOutlined } from "@ant-design/icons";
import React from "react";

enum CopyableEnum {
  id = "Salin",
  pk = "Copy",
  bd = "কপি"
}
const country = process.env.REACT_APP_COUNTRY;

export const Copyable = () => (
  <>
    <CopyOutlined />
    {CopyableEnum[country as keyof typeof CopyableEnum]}
  </>
);
